import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import IconPng from 'atoms/IconPng'
import { FormSelect, FormNumber, FormSwitch, FormTxtArea } from 'atoms/Inputs'
import {
  LevelRowContainer,
  Accordion,
  CardContainer,
} from './styles'
import { v4 as uuidv4 } from 'uuid';
import Geometri from './Geometri'
import Attachments from './Attachments'
import lo from 'lodash'
import { BLASTING_REPORT, BLASTING_REPORT_PIT_INFO } from 'fixtures/api';
import { getLookup } from 'Redux/actions/LookupActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ExplosiveUsage from './ExplosiveUsage'

const ic_arrow_up = require('App/assets/images/ic_arrow_up.png')
const ic_arrow_down = require('App/assets/images/ic_arrow_down.png')

export class DetailPit extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isDetailPitExpanded: false,
    }
  }

  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup() {
    const { getLookup, toggleIsLoading } = this.props
    toggleIsLoading(true)
    getLookup(BLASTING_REPORT, BLASTING_REPORT_PIT_INFO)
    toggleIsLoading(false)
  }

  showDetailPit() {
    const { isDetailPitExpanded } = this.state
    this.setState({ isDetailPitExpanded: !isDetailPitExpanded })
  }

  addPit() {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const newDetailPit = {
      id: uuidv4(),
      pitInfo: {
        pit: '-',
        sectionFrom: '',
        sectionTo: '',
        rl: '',
        negativeRl: false,
        actual: '',
        negativeActual: false,
        hole: '',
        negativeHole: false,
        hardness: '-',
        remark: '',
        powderFactor: '',
        volumeBlasting: '',
        explosiveUsage: '',
        rlDesign: '',
        negativeRlDesign: false,
      },
      geometri: {
        burden: '',
        spacing: '',
        depth: '',
        stemming: '',
        diameter: '-',
        numOfHole: '',
      },
      explosiveUsage: {
        explosiveType: '-',
        downToHole: '',
        amoniumNitrate: '',
        dynamites: [
          {
            id: uuidv4(),
            dynamiteType: '-',
            dynamiteWeight: '-',
            dynamiteAmount: ''
          }
        ],
        inholes: [
          {
            id: uuidv4(),
            inholeType: '-',
            inholeLength: '-',
            inholeAmount: ''
          }
        ],
        surfaces: [
          {
            id: uuidv4(),
            surfaceType: '-',
            surfaceLength: '-',
            surfaceAmount: ''
          }
        ],
        detonatorType: '-',
        detonatorAmount: '',
      },
      attachments: []
    }
    details.detailPit.push(newDetailPit)
    fnChange(details, 'details')
  }

  removePit(id) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    // at least 1 pit item, only remove if length > 1
    if (details.detailPit.length > 1) {
      document.getElementById(`attachments-${id}`).value = null
      const updatedDetailPit = details.detailPit.filter(pit => pit.id !== id);
      details.detailPit = updatedDetailPit
      fnChange(details, 'details')
    }
  }

  onChangeVal(value, id, field) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === id));
    details.detailPit[pitIndex]['pitInfo'][field] = value
    fnChange(details, 'details')
  }

  render() {
    const { theme, blastingReportData, lookups, pitOptions, isDisabled, formRefs } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <>
        <Accordion
          color={theme.mocaPurple}
          height={'37px'}
          padding={'0px 12px'}
          bg={'#EBEAFF'}
          mb={this.state.isDetailPitExpanded ? '0' : '8px'}
          onClick={() => this.showDetailPit()}
        >
          Detail PIT
          {
            this.state.isDetailPitExpanded ? (
              <IconPng srcIcon={ic_arrow_up} mx={"8px"} size={"auto"} h={"10"} />
            ) : (
              <IconPng srcIcon={ic_arrow_down} mx={"8px"} size={"auto"} h={"10"} />
            )
          }
        </Accordion>
        {this.state.isDetailPitExpanded && 
            <CardContainer mb={'16px'}>
              {blastingReportData.hasOwnProperty('details') && 
                <>
                  {blastingReportData.details.detailPit.map((pit, idx) => 
                    <LevelRowContainer key={idx} padding={idx === 0 ? '4px 0px': '16px 0px 4px'} borderNone={idx === 0}>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-6 px-0'}>
                          <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={'#473A94'}>
                            PIT Info
                          </Label>
                        </div>
                        <div className={'col-6 px-0 d-flex justify-content-end'}>
                          <ButtonReg 
                            onClick={() => this.removePit(pit.id)} 
                            btnIcon={'trash-alt'}
                            btnIconColor={'red'}
                            btnTxt={'Delete PIT'}
                            color={'red'}
                            bg={'white'}
                            size={'12px'}
                            height={'21px'}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-4 px-0 pr-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            PIT
                          </Label>
                          <FormSelect
                            placeholder={'Select PIT'}
                            onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'pit')}
                            options={pitOptions || []}
                            disabled={isDisabled}
                            value={pit.pitInfo.pit}
                            valField={'id'}
                            dispField={'name'}
                            arrowSize={'16px'}
                            ref={(ref) => (formRefs[`pit_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-4 px-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Section From
                          </Label>
                          <FormNumber
                            placeholder={'Enter section'}
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'sectionFrom')}
                            value={pit.pitInfo.sectionFrom}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`sectionFrom_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-4 px-0 pl-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Section To
                          </Label>
                          <FormNumber
                            placeholder={'Enter section'}
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'sectionTo')}
                            value={pit.pitInfo.sectionTo}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`sectionTo_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-4 px-0 pr-2'}>
                          <div className={'row col-12 mx-0 px-0 d-flex justify-content-between'}>
                            <div className={'px-0'}>
                              <Label lineheight={'14px'} size={'12px'}>
                                RL
                              </Label>
                            </div>
                            <div className={'px-0 d-flex align-items-center'}>
                              <div className={'row mx-0 px-0'}>
                                <FormSwitch
                                  id={`switch-rl-${pit.id}`}
                                  toggled={pit.pitInfo.negativeRl}
                                  onChange={() => !isDisabled ? this.onChangeVal(!pit.pitInfo.negativeRl, pit.id, 'negativeRl') : {}}
                                  marginRight={'4px'}
                                />
                                <Label lineheight={'16px'} size={'12px'} weight={'normal'} mb={'0'}>
                                  Negative
                                </Label>
                              </div>
                            </div>
                          </div>
                          <FormNumber
                            placeholder={'0'}
                            alignRight
                            negative={pit.pitInfo.negativeRl}
                            allowNegative
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'rl')}
                            value={pit.pitInfo.rl}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`rl_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-4 px-2'}>
                          <div className={'row col-12 mx-0 px-0 d-flex justify-content-between'}>
                            <div className={'px-0'}>
                              <Label lineheight={'14px'} size={'12px'}>
                                Actual
                              </Label>
                            </div>
                            <div className={'px-0 d-flex align-items-center'}>
                              <div className={'row mx-0 px-0'}>
                                <FormSwitch
                                  id={`switch-actual-${pit.id}`}
                                  toggled={pit.pitInfo.negativeActual}
                                  onChange={() => !isDisabled ? this.onChangeVal(!pit.pitInfo.negativeActual, pit.id, 'negativeActual') : {}}
                                  marginRight={'4px'}
                                />
                                <Label lineheight={'16px'} size={'12px'} weight={'normal'} mb={'0'}>
                                  Negative
                                </Label>
                              </div>
                            </div>
                          </div>
                          <FormNumber
                            placeholder={'0'}
                            alignRight
                            negative={pit.pitInfo.negativeActual}
                            allowNegative
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'actual')}
                            value={pit.pitInfo.actual}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`actual_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-4 px-0 pl-2'}>
                          <div className={'row col-12 mx-0 px-0 d-flex justify-content-between'}>
                            <div className={'px-0'}>
                              <Label lineheight={'14px'} size={'12px'}>
                                Hole
                              </Label>
                            </div>
                            <div className={'px-0 d-flex align-items-center'}>
                              <div className={'row mx-0 px-0'}>
                                <FormSwitch
                                  id={`switch-hole-${pit.id}`}
                                  toggled={pit.pitInfo.negativeHole}
                                  onChange={() => !isDisabled ? this.onChangeVal(!pit.pitInfo.negativeHole, pit.id, 'negativeHole') : {}}
                                  marginRight={'4px'}
                                />
                                <Label lineheight={'16px'} size={'12px'} weight={'normal'} mb={'0'}>
                                  Negative
                                </Label>
                              </div>
                            </div>
                          </div>
                          <FormNumber
                            placeholder={'0'}
                            alignRight
                            negative={pit.pitInfo.negativeHole}
                            allowNegative
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'hole')}
                            value={pit.pitInfo.hole}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`hole_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-6 px-0 pr-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Hardness <span style={{color: theme.mocaOrange}}>(MPA)</span>
                          </Label>
                          <FormSelect
                            placeholder={'Select hardness'}
                            onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'hardness')}
                            options={lookups.blastingReportHardness || []}
                            value={pit.pitInfo.hardness}
                            disabled={isDisabled}
                            valField={'name'}
                            dispField={'name'}
                            arrowSize={'16px'}
                            mb={'16px'}
                            ref={(ref) => (formRefs[`hardness_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-12 px-0'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Remark
                          </Label>
                          <FormTxtArea
                            placeholder={'Enter remark'}
                            rows="3"
                            mb={'16px'}
                            onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'remark')}
                            value={pit.pitInfo.remark}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`remark_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-6 px-0 pr-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Powder Factor
                          </Label>
                          <FormNumber
                            placeholder={'Enter powder factor'}
                            isDecimal
                            fractionDigits={3}
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'powderFactor')}
                            value={pit.pitInfo.powderFactor}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`powderFactor_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-6 px-0 pl-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Volume Blasting <span style={{color: theme.mocaOrange}}>(BCM)</span>
                          </Label>
                          <FormNumber
                            placeholder={'Enter volume blasting'}
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'volumeBlasting')}
                            value={pit.pitInfo.volumeBlasting}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`volumeBlasting_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <div className={'row col-12 mx-0 px-0'}>
                        <div className={'col-6 px-0 pr-2'}>
                          <Label lineheight={'14px'} size={'12px'}>
                            Explosive usage <span style={{color: theme.mocaOrange}}>(KG)</span>
                          </Label>
                          <FormNumber
                            placeholder={'Enter explosive usage'}
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'explosiveUsage')}
                            value={pit.pitInfo.explosiveUsage}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`explosiveUsage_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                        <div className={'col-6 px-0 pl-2'}>
                          <div className={'row col-12 mx-0 px-0 d-flex justify-content-between'}>
                            <div className={'px-0'}>
                              <Label lineheight={'14px'} size={'12px'}>
                                RL Design
                              </Label>
                            </div>
                            <div className={'px-0 d-flex align-items-center'}>
                              <div className={'row mx-0 px-0'}>
                                <FormSwitch
                                  id={`switch-rl-design-${pit.id}`}
                                  toggled={pit.pitInfo.negativeRlDesign}
                                  onChange={() => !isDisabled ? this.onChangeVal(!pit.pitInfo.negativeRlDesign, pit.id, 'negativeRlDesign') : {}}
                                  marginRight={'4px'}
                                />
                                <Label lineheight={'16px'} size={'12px'} weight={'normal'} mb={'0'}>
                                  Negative
                                </Label>
                              </div>
                            </div>
                          </div>
                          <FormNumber
                            placeholder={'0'}
                            alignRight
                            negative={pit.pitInfo.negativeRlDesign}
                            allowNegative
                            mb={'16px'}
                            onChangeVal={value => this.onChangeVal(value, pit.id, 'rlDesign')}
                            value={pit.pitInfo.rlDesign}
                            disabled={isDisabled}
                            ref={(ref) => (formRefs[`rlDesign_${pit.id}`] = ref)}
                            {...inputConfig}
                          />
                        </div>
                      </div>
                      <Geometri pit={pit} {...this.props}/>
                      <ExplosiveUsage pit={pit} {...this.props}/>
                      <Attachments pit={pit} {...this.props} />
                    </LevelRowContainer>
                  )}
                </>
              }
              <LevelRowContainer padding={'0px'}>
                <div className={'row col-12 mx-0 px-0 d-flex justify-content-center'}>
                  <ButtonReg transparent btnTxt={'Add PIT'} onClick={() => this.addPit()} disabled={isDisabled}/>
                </div>
              </LevelRowContainer>
            </CardContainer>
          }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BLASTING_REPORT) {
    const blastingReport = state.lookups.data.BLASTING_REPORT
    const blastingReportHardness = blastingReport.BLASTING_REPORT_PIT_INFO && blastingReport.BLASTING_REPORT_PIT_INFO.find((d) => d.name === 'HARDNESS')
    lookups.blastingReportHardness = blastingReportHardness ? blastingReportHardness.children.map((d) => ({ name: d.nameDisplay })) : []
  }
  return {
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DetailPit)
)
